<template>
	<div class="navigations">
		<el-menu :router="true" :default-active="path" class="el-menu-demo" mode="horizontal" @select="handleSelect"
			@open="handleOpen" @close="handleClose" text-color="#fff" active-text-color="#fff">
			<div class="navigations-left">
				<img class="navigations-logo" src="../../assets/logo.png" alt="">
				<img class="navigations-logo2" src="../../assets/logo-2.png" alt="">
			</div>
			<div class="navigations-right">
				<el-menu-item :class="path == '/index'?'navigations-tag navigations-active':'navigations-tag'"
					index="/index">首页</el-menu-item>
				<el-menu-item :class="path == '/about'?'navigations-tag navigations-active':'navigations-tag'"
					index="/about">关于我们</el-menu-item>
				<el-menu-item :class="path == '/enterprise'?'navigations-tag navigations-active':'navigations-tag'"
					index="/enterprise">企业文化</el-menu-item>
				<el-menu-item :class="path == '/store'?'navigations-tag navigations-active':'navigations-tag'"
					index="/store">商家入驻</el-menu-item>
				<el-menu-item :class="path == '/recruit'?'navigations-tag navigations-active':'navigations-tag'"
					index="/recruit">人才招聘</el-menu-item>
				<el-menu-item :class="path == '/user'?'navigations-tag-end navigations-active':'navigations-tag-end'"
					index="/user">用户体验</el-menu-item>
				<i class="el-icon-more answer-nav-menu" @click="showAnswerNav"></i>
			</div>
			<div class="navigations-right-answer" v-show="activeAnswerNav">
				<el-menu-item class="answer-tag" index="/indexH5">首页</el-menu-item>
				<el-menu-item class="answer-tag" index="/about">关于我们</el-menu-item>
				<el-menu-item class="answer-tag" index="/enterprise">企业文化</el-menu-item>
				<el-menu-item class="answer-tag" index="/store">商家入驻</el-menu-item>
				<el-menu-item class="answer-tag" index="/recruit">人才招聘</el-menu-item>
				<el-menu-item class="answer-tag" index="/user">用户体验</el-menu-item>
			</div>
		</el-menu>
	</div>
</template>

<script>
	export default {
		name: 'navigations',
		props: {
			path: String
		},
		data() {
			return {
				activeAnswerNav: false,
			};
		},
		methods: {
			handleSelect(key, keyPath) {
				window.location.href = '#app'
				this.$router.push(key)
			},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			showAnswerNav() {
				this.activeAnswerNav = !this.activeAnswerNav;
			}
		}
	}
</script>

<style>
	.navigations {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 10;
	}

	.el-menu-demo {
		background-image: linear-gradient(to right, #9867fe, #33cccc) !important;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		height: 100px;
	}

	.navigations-left {
		width: 50%;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
		align-content: center;
		align-items: center;
		padding-left: 30px;
	}

	.navigations-right {
		width: 50%;
		padding-right: 5%;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: flex-end;
		align-items: center;
	}

	.navigations-logo {
		height: 50px;
	}

	.navigations-logo2 {
		margin-left: 100px;
		height: 40px;
		display: inline;
	}

	.navigations-tag {
		border-right: 1px solid #fff;
		height: 35px;
		line-height: 35px;
		font-size: 20px;
		font-weight: 500;
	}

	.navigations-tag-end {
		height: 35px;
		line-height: 35px;
		font-size: 20px;
		font-weight: 500;
	}

	.navigations-active {
		text-shadow: 0px 0px 3px #9867fe;
	}

	.answer-nav-menu {
		display: none;
	}

	@media screen and (max-width: 768px) {
		.el-menu-demo{
			height: 70px;
		}
		
		.navigations-logo {
			width: 180px;
			height: auto;
		}

		.navigations-logo2 {
			width: 100px;
			margin-left: 15px;
			height: 18px;
			display: none;
		}

		.navigations-tag-end {
			display: none;
		}

		.navigations-tag {
			display: none;
		}

		.el-submenu__title {
			width: 100px !important;
		}

		.answer-nav-menu {
			color: #fff !important;
			display: inline;
		}

		.el-submenu__title i {
			color: #fff !important;
		}

		.answer-tag {
			color: #fff;
			background-image: linear-gradient(to right, #9867fe, #33cccc) !important;
			text-align: center;
			margin-top: -1px;
		}

		.el-menu--popup {
			min-width: 120px !important;
			background-image: linear-gradient(to right, #9867fe, #33cccc) !important;
		}

		.navigations-right-answer {
			width: 100%;
			position: absolute;
			top: 70px;
			-webkit-transition: height 1s;
			transition: height 1s;
		}
	}
</style>